import { menu } from './menu';
import { router } from './router';

export const Koncernove = {
	menu,
	router,
};
